import { render, staticRenderFns } from "./ItemAccountEditView.vue?vue&type=template&id=1daa5663"
import script from "./ItemAccountEditView.vue?vue&type=script&lang=js"
export * from "./ItemAccountEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports